module.exports = __webpack_public_path__ + "img/url.354e487f.svg";